var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconFlexible(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    className: "svg-icon",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_14829_10222)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M32.6128 5.51123H6.61279V10.0014H32.6128V5.51123Z",
    fill: "#3338D2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.0295 20.2214H14.7378V23.0278H12.0295V20.2214ZM18.439 20.2214H21.1473V23.0278H18.439V20.2214ZM24.8485 20.2214H27.5569V23.0278H24.8485V20.2214ZM12.0295 14.7957H14.7378V17.602H12.0295V14.7957ZM18.439 14.7957H21.1473V17.602H18.439V14.7957ZM24.8485 14.7957H27.5569V17.602H24.8485V14.7957ZM6.61279 30.5112H32.6128V9.93115H6.61279V30.5112Z",
    fill: "#8896FF"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_14829_10222"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 26,
    height: 25,
    fill: "white",
    transform: "translate(6.61279 5.51123)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlexible);
export default __webpack_public_path__ + "static/media/icon_flexible.6aa173d92f2e1dc618cb89d8eedf748d.svg";
export { ForwardRef as ReactComponent };